import React, { Fragment, useState } from 'react'
import LinkButton from '../../../../common/LinkButton'
import NotesImg from '../../../../../assets/icons/notes.svg'
import moment from 'moment'
import CenteredModal from '../../../../common/CenteredModal'
import MessageCard from '../../../../common/MessageCard'
import './style.sass'

const VersionApprovedDate = ({ release }) => {

  // ==== Local state ====
  const [isModalOpen, setIsModalOpen] = useState(false)

  // ==== Methods ====
  const getApprovedDate = () => {
    const formattedDate = moment(release?.commentByAdmin?.createdDate).format('Do MMMM YYYY')
    return formattedDate
  }

  const getApplication = () => {
    // Parsing release.data to get the application object
    let app = null
    try {
      app = release?.data ? JSON.parse(release?.data) : null
    } catch (e) {
      /* Fail Silently */
    }
    return app
  }

  const renderReleaseNotesModal = () => {
    return (
      <CenteredModal
        show={isModalOpen}
        title={`Notes | v${release?.version?.toFixed(1)} - ${getApplication()?.name}`}
        showSuccessBtn={false}
        cancelBtnText="Close"
        onHide={() => {
          setIsModalOpen(false)
        }}
      >
        <Fragment>
          <MessageCard
            title="Release Note"
            icon="info-circle"
            type="info"
          >
            {release?.commentByVendor?.commentText || 'N/A'}
          </MessageCard>
          <MessageCard
            title="Reviewer Note"
            icon="info-circle"
          >
            {release?.commentByAdmin?.commentText || 'N/A'}
          </MessageCard>
        </Fragment>
      </CenteredModal>
    )
  }

  return (
    <div className='version-approved-date-component'>
      <div className='inner-row-container'>
        <label className='label-text'>Version approved on <b>{getApprovedDate()}</b></label>
        <LinkButton
          btnText="View release note"
          imgIcon={NotesImg}
          onClick={() => setIsModalOpen(true)}
        />
      </div>
      {renderReleaseNotesModal()}
    </div>
  )
}

export default VersionApprovedDate
